import classNames from 'classnames';
import Tooltip from '@components/core/Tooltip';
import { useTranslations } from '@components/context';

/** True when a step may lock applications: never the first step, where every application starts, nor an outcome. */
export const isApplicationLockAvailable = ({ isFirstStep, stepType }) => !isFirstStep && !stepType?.is_outcome;

const ApplicationLockField = ({ locked, disabled, onChange }) => {
    const { t } = useTranslations();
    const label = t('Applicants cannot edit their application from this step onwards');

    return (
        <div className="application-lock-setting-container">
            <div className="group-switch">
                <button
                    type="button"
                    className={classNames('toggle-button', 'toggle-switch-rounded', {
                        active: locked,
                        readonly: disabled,
                    })}
                    aria-pressed={locked}
                    aria-label={label}
                    disabled={disabled}
                    data-action="toggle-application-lock"
                    onClick={() => onChange(!locked)}
                >
                    <Tooltip title={label}>
                        <span className="icon icon-svg-lock-01" />
                    </Tooltip>
                </button>
            </div>
        </div>
    );
};

export default ApplicationLockField;
